import { lazy } from 'react'
import ReactOnRails from 'react-on-rails'

// Setup ActionCable consumer globally for backward compatibility
import getConsumer from '../channels/consumer'

// Create global App object to match old asset pipeline structure
window.App = window.App || {}
window.App.cable = getConsumer()

const AboutFAQ = lazy(() => import(/* webpackChunkName: 'about-faq' */ '../bundles/pages/AboutFAQ/AboutFAQ'))
const AboutFirstJobs = lazy(() => import(/* webpackChunkName: 'about-first-jobs' */ '../bundles/pages/AboutFirstJobs/AboutFirstJobs'))
const AboutInternships = lazy(() => import(/* webpackChunkName: 'about-internships' */ '../bundles/pages/AboutInternships/AboutInternships'))
const AboutKotOwners = lazy(() => import(/* webpackChunkName: 'about-kot-owners' */ '../bundles/pages/AboutKotOwners/AboutKotOwners'))
const AboutKots = lazy(() => import(/* webpackChunkName: 'about-kots' */ '../bundles/pages/AboutKots/AboutKots'))
const AboutPress = lazy(() => import(/* webpackChunkName: 'about-press' */ '../bundles/pages/AboutPress/AboutPress'))
const AboutSummerJobs = lazy(() => import(/* webpackChunkName: 'about-summer-jobs' */ '../bundles/pages/AboutSummerJobs/AboutSummerJobs'))
const AboutTerms = lazy(() => import(/* webpackChunkName: 'about-terms' */ '../bundles/pages/AboutTerms/AboutTerms'))
const AboutUs = lazy(() => import(/* webpackChunkName: 'about-us' */ '../bundles/pages/AboutUs/AboutUs'))
const AboutAcademicServices = lazy(() => import(/* webpackChunkName: 'about-academic-services' */ '../bundles/pages/AboutAcademicServices/AboutAcademicServices'))
const AlertPage = lazy(() => import(/* webpackChunkName: 'alert-page' */ '../bundles/pages/Alert/AlertPage'))
const CompanyArticles = lazy(() => import(/* webpackChunkName: 'company-articles' */ '../bundles/pages/user/Articles/CompanyArticles'))
const CompanyPage = lazy(() => import(/* webpackChunkName: 'company-page' */ '../bundles/pages/user/CompanyPage/CompanyPage'))
const CompanyProfileFormPage = lazy(() => import(/* webpackChunkName: 'company-profile-form' */ '../bundles/pages/user/CompanyProfileForm/CompanyProfileFormPage'))
const Congratulation = lazy(() => import(/* webpackChunkName: 'congratulation' */ '../bundles/pages/user/Congratulation/Congratulation'))
const ContactMain = lazy(() => import(/* webpackChunkName: 'contact-main' */ '../bundles/pages/Contact/ContactMain'))
const ContactEmployerPage = lazy(() => import(/* webpackChunkName: 'contact-employer' */ '../bundles/pages/Contact/ContactEmployerPage'))
const EmailConfirmationPage = lazy(() => import(/* webpackChunkName: 'email-confirmation' */ '../bundles/pages/user/EmailConfirmationPage/EmailConfirmationPage'))
const EmployerJobIndex = lazy(() => import(/* webpackChunkName: 'employer-job-index' */ '../bundles/pages/user/EmployerJobIndex/EmployerJobIndex'))
const ForgotPassword = lazy(() => import(/* webpackChunkName: 'forgot-password' */ '../bundles/pages/user/ForgotPassword/ForgotPassword'))
const HeadHunt = lazy(() => import(/* webpackChunkName: 'headhunt' */ '../bundles/pages/user/Headhunt/HeadHunt/HeadHunt'))
const HeadhuntResponse = lazy(() => import(/* webpackChunkName: 'headhunt-response' */ '../bundles/pages/user/Headhunt/HeadhuntResponse/HeadhuntResponse'))
const HomeEmployer = lazy(() => import(/* webpackChunkName: 'home-employer' */ '../bundles/pages/HomeEmployer/HomeEmployer'))
const HomeMyBSPage = lazy(() => import(/* webpackChunkName: 'home-mybs' */ '../bundles/pages/HomeMyBS/HomeMyBSPage'))
const HomeStudentMain = lazy(() => import(/* webpackChunkName: 'home-student' */ '../bundles/pages/HomeStudent/HomeStudentMain'))
const IndexRouter = lazy(() => import(/* webpackChunkName: 'index-router' */ '../bundles/router/IndexRouter'))
const TechlinkIFrame = lazy(() => import(/* webpackChunkName: 'techlink-iframe' */ '../bundles/iframe/techlink/TechlinkIFrame'))
const StartupEcosystemIFrame = lazy(() => import(/* webpackChunkName: 'startup-ecosystem-iframe' */ '../bundles/iframe/startup_ecosystem/StartupEcosystemIFrame'))
const FirstJobFunnel = lazy(() => import(/* webpackChunkName: 'first-job-funnel' */ '../bundles/pages/user/JobCreationFunnel/FirstJobFunnel/FirstJobFunnel'))
const InternshipFunnel = lazy(() => import(/* webpackChunkName: 'internship-funnel' */ '../bundles/pages/user/JobCreationFunnel/InternshipFunnel/InternshipFunnel'))
const StudentJobFunnel = lazy(() => import(/* webpackChunkName: 'student-job-funnel' */ '../bundles/pages/user/JobCreationFunnel/StudentJobFunnel/StudentJobFunnel'))
const JobResults = lazy(() => import(/* webpackChunkName: 'job-results' */ '../bundles/pages/user/JobResults/JobResults'))
const JobSearchStatusResponse = lazy(() => import(/* webpackChunkName: 'job-search-status' */ '../bundles/pages/user/Profile/StudentProfile/Components/JobSearchStatusResponse/JobSearchStatusResponse'))
const LoginRegister = lazy(() => import(/* webpackChunkName: 'login-register' */ '../bundles/pages/LoginRegister/LoginRegister/LoginRegister'))
const Lost = lazy(() => import(/* webpackChunkName: 'lost-page' */ '../bundles/pages/Lost/Lost'))
const MessageMainEmployer = lazy(() => import(/* webpackChunkName: 'messages-employer' */ '../bundles/pages/user/Messages/MessagesMain/MessageMainEmployer'))
const MessageMainKotOwner = lazy(() => import(/* webpackChunkName: 'messages-kot-owner' */ '../bundles/pages/user/Messages/MessagesMain/MessageMainKotOwner'))
const MessageMainStudent = lazy(() => import(/* webpackChunkName: 'messages-student' */ '../bundles/pages/user/Messages/MessagesMain/MessageMainStudent'))
const MultiStepRegister = lazy(() => import(/* webpackChunkName: 'multi-step-register' */ '../bundles/pages/LoginRegister/Register/MultiStepRegister/MultiStepRegister'))
const MyItemSelectionIndexMain = lazy(() => import(/* webpackChunkName: 'my-item-selection' */ '../bundles/pages/user/MyItemSelection/MyItemSelectionIndex/MyItemSelectionIndexMain'))
const MyAlertsIndex = lazy(() => import(/* webpackChunkName: 'my-alerts' */ '../bundles/pages/user/MyAlertsIndex/MyAlertsIndex'))
const MyKotIndex = lazy(() => import(/* webpackChunkName: 'my-kots' */ '../bundles/pages/user/MyKotIndex/MyKotIndex'))
const NewJobForm = lazy(() => import(/* webpackChunkName: 'new-job-form' */ '../bundles/pages/user/JobCreationFunnel/NewJob/NewJobForm'))
const NewArticle = lazy(() => import(/* webpackChunkName: 'new-article' */ '../bundles/pages/user/NewArticle/NewArticle'))
const NewKot = lazy(() => import(/* webpackChunkName: 'new-kot' */ '../bundles/pages/user/NewKot/NewKot'))
const NewPassword = lazy(() => import(/* webpackChunkName: 'new-password' */ '../bundles/pages/user/NewPassword/NewPassword'))
const PaymentPage = lazy(() => import(/* webpackChunkName: 'payment-page' */ '../bundles/pages/AboutPayment/PaymentPage'))
const PersonalDashboard = lazy(() => import(/* webpackChunkName: 'personal-dashboard' */ '../bundles/pages/user/PersonalDashboard/PersonalDashboard'))
const Profile = lazy(() => import(/* webpackChunkName: 'profile' */ '../bundles/pages/user/Profile/Profile'))
const PromotionRouter = lazy(() => import(/* webpackChunkName: 'promotion-router' */ '../bundles/router/pages/PromotionRouter'))
const SignInRedirection = lazy(() => import(/* webpackChunkName: 'signin-redirect' */ '../bundles/pages/SignInRedirection/SignInRedirection'))
const Settings = lazy(() => import(/* webpackChunkName: 'settings' */ '../bundles/pages/user/Settings/Settings'))
const Welcome = lazy(() => import(/* webpackChunkName: 'welcome' */ '../bundles/pages/user/Welcome/Welcome'))
const JobListingGenerator = lazy(() => import(/* webpackChunkName: 'job-listing-generator' */ '../bundles/pages/user/JobCreationFunnel/JobListingGenerator/JobListingGenerator'))

// Landing Pages
const JobfairsLandingPage = lazy(() => import(/* webpackChunkName: 'landing-jobfairs' */ '../bundles/pages/LandingPages/JobfairsLandingPage'))
const PodcastPage = lazy(() => import(/* webpackChunkName: 'landing-podcast' */ '../bundles/pages/LandingPages/PodcastPage'))
const StartupsLandingPage = lazy(() => import(/* webpackChunkName: 'landing-startups' */ '../bundles/pages/LandingPages/StartupsLandingPage'))
const RecruitmentSelectionPage = lazy(() => import(/* webpackChunkName: 'landing-recruitment' */ '../bundles/pages/LandingPages/RecruitmentSelectionPage'))
const StudentJobLandingPage = lazy(() => import(/* webpackChunkName: 'landing-student-jobs' */ '../bundles/pages/LandingPages/StudentJobLandingPage'))

// Admin components
const AdminDocs = lazy(() => import(/* webpackChunkName: 'admin-docs' */ '../bundles/Admin/AdminDocs')) 
const AdminEditAd = lazy(() => import(/* webpackChunkName: 'admin-edit-ad' */ '../bundles/Admin/Ads/AdminEditAd'))
const AdminEditArticle = lazy(() => import(/* webpackChunkName: 'admin-edit-article' */ '../bundles/Admin/Articles/AdminEditArticle'))
const AdminEditCompany = lazy(() => import(/* webpackChunkName: 'admin-edit-company' */ '../bundles/Admin/Companies/AdminEditCompany'))
const AdminEditFeaturedSchool = lazy(() => import(/* webpackChunkName: 'admin-edit-school' */ '../bundles/Admin/FeaturedSchools/AdminEditFeaturedSchool'))
const AdminEditVideo = lazy(() => import(/* webpackChunkName: 'admin-edit-video' */ '../bundles/Admin/Videos/AdminEditVideo'))
const AdminDashboard = lazy(() => import(/* webpackChunkName: 'admin-dashboard' */ '../bundles/Admin/AdminDashboard'))
const AdminExports = lazy(() => import(/* webpackChunkName: 'admin-exports' */ '../bundles/Admin/AdminExports'))
const AdminHealthMetrics = lazy(() => import(/* webpackChunkName: 'admin-health' */ '../bundles/Admin/AdminHealthMetrics'))
const AdminDataPage = lazy(() => import(/* webpackChunkName: 'admin-data' */ '../bundles/pages/AdminDataPage/AdminDataPage'))

// This is how react_on_rails can see the HelloWorld in the browser.
// Only put components in this file that are called in the view, otherwise, they are useless.

ReactOnRails.register({
    AboutFAQ,
    AboutFirstJobs,
    AboutInternships,
    AboutKotOwners,
    AboutKots,
    AboutPress,
    AboutSummerJobs,
    AboutTerms,
    AboutAcademicServices,
    AboutUs,
    AlertPage,
    AdminEditVideo,
    CompanyArticles,
    CompanyPage,
    CompanyProfileFormPage,
    Congratulation,
    EmailConfirmationPage,
    ContactMain,
    ContactEmployerPage,
    EmployerJobIndex,
    FirstJobFunnel,
    ForgotPassword,
    HeadHunt,
    HeadhuntResponse,
    HomeEmployer,
    HomeMyBSPage,
    HomeStudentMain,
    IndexRouter,
    InternshipFunnel,
    JobResults,
    JobSearchStatusResponse,
    JobfairsLandingPage,
    LoginRegister,
    Lost,
    MessageMainEmployer,
    MessageMainKotOwner,
    MessageMainStudent,
    MultiStepRegister,
    MyItemSelectionIndexMain,
    MyAlertsIndex,
    MyKotIndex,
    NewArticle,
    NewJobForm,
    NewKot,
    NewPassword,
    PaymentPage,
    PersonalDashboard,
    AdminDataPage,
    PodcastPage,
    StartupsLandingPage,
    Profile,
    PromotionRouter,
    RecruitmentSelectionPage,
    Settings,
    SignInRedirection,
    StudentJobFunnel,
    StudentJobLandingPage,
    TechlinkIFrame,
    StartupEcosystemIFrame,
    Welcome,
    AdminDashboard,
    AdminDocs,
    AdminEditAd,
    AdminEditArticle,
    AdminEditCompany,
    AdminEditFeaturedSchool,
    AdminExports,
    AdminHealthMetrics,
    JobListingGenerator
})

// Import Rails Admin styles
import '../stylesheets/rails_admin.scss'

// Import ActionCable channels
import '../channels/conversations_channel'
import '../channels/notification_rooms_channel'
